<ng-select
  [items]="items"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [(ngModel)]="selectedValue"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [searchable]="searchable"
  [clearable]="clearable"
  [loading]="loading"
  [compareWith]="compareWith"
  [class.is-invalid]="isInvalid"
  (search)="onSearch($event)"
  (change)="onChangeSelection($event)"
  (clear)="onClear()">

  <!-- Template personalizado para opciones -->
  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div class="ng-select-item-content">
      <div [ngClass]="showSecondaryText ? 'fw-semibold' : 'text-normal'">
        {{ item[bindLabel] }}
      </div>
      <div class="text-muted small" *ngIf="showSecondaryText && item[secondaryTextField]">
        <i [class]="iconClass + ' me-1'"></i>{{ item[secondaryTextField] }}
      </div>
    </div>
  </ng-template>

  <!-- Template personalizado para label (cuando está seleccionado) -->
  <ng-template ng-label-tmp let-item="item">
    <div class="ng-select-label-content">
      <span>{{ item[bindLabel] }}</span>
    </div>
  </ng-template>

  <!-- Template cuando no hay resultados -->
  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
    <div class="p-3 text-center text-muted">
      <i class="ri-search-line fs-4 d-block mb-2"></i>
      No se encontraron resultados
    </div>
  </ng-template>
</ng-select>
